export interface DatePeriod {
  start: string
  end: string
}

// lukita stores the number, the type and the owner as separate columns and militao renders
// them side by side, so nothing here holds a joined label like "Checking ..1234". A combined
// mailing is a list of numbers, not a string with a plus in it.
export const ACCOUNT_TYPES = [
  'checking',
  'savings',
  'credit_card',
  'debit_card',
  'loan',
  'investment',
  'retirement',
  'other',
] as const

export type AccountType = (typeof ACCOUNT_TYPES)[number]

// Two accounts at one bank can print the same last four digits, so the number is not the key.
export interface Account {
  id: string
  numbers: string[]
  accountType: AccountType | null
  owner: string | null
  institution: string | null
}

// Which upload a page was scanned in, and which sheet of it. A project holds many uploads, so
// the file a page came from is how anyone finds it again, and it never moves with the page.
export interface PageSource {
  fileId: number
  fileUrl: string
  fileName: string
  pageInFile: number
}

export interface DocumentPage {
  // Where the page sits once every upload in the project is laid end to end. It is an id, not
  // something to show anyone: what a person reads is the file and the sheet inside it.
  number: number
  source: PageSource
}

export interface PageGroup {
  id: string
  pages: number[]
  period: DatePeriod | null
  accountId: string | null
}

// Every page of every upload in the project, laid end to end.
export interface SourceDocument {
  pages: DocumentPage[]
}

// Which account and which dates this statement is filed under. Both are the machine's reading
// at first and the user's word after that, so both are stored, not derived from the pages.
export interface Statement {
  id: string
  period: DatePeriod | null
  accountId: string | null
}

// How the file is filed: the accounts it is filed under, the statements, and the page each
// one holds. Every page belongs to exactly one statement, so a gap or an overlap cannot be
// expressed. The accounts live here and not in the document because the user can edit them.
export interface Arrangement {
  accounts: Account[]
  statements: Statement[]
  ownerByPage: ReadonlyMap<number, string>
}

export interface StatementView {
  statement: Statement
  pages: number[]
}
